// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"user-info_wrapper__Ng9hJ","west":"user-info_west__1j7zK","middle":"user-info_middle__1s_oA","east":"user-info_east__KaUsg"};